// SPDX-FileCopyrightText: 2022-2026 Lablup Inc. All rights reserved.
// SPDX-License-Identifier: LicenseRef-Proprietary
import "antd/dist/reset.css";
import { Provider as JotaiProvider } from "jotai";
import { parse, stringify } from "query-string";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryParamProvider } from "use-query-params";
import { ReactRouter6Adapter } from "use-query-params/adapters/react-router-6";

import App from "./App";
import { jotaiStore } from "./jotaiStore";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <JotaiProvider store={jotaiStore}>
      <BrowserRouter>
        <QueryParamProvider
          adapter={ReactRouter6Adapter}
          options={{
            searchStringToObject: parse,
            objectToSearchString: stringify,
          }}
        >
          <App />
        </QueryParamProvider>
      </BrowserRouter>
    </JotaiProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
